import React, { useState, useEffect, useContext } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";
import HandleHttpErrors from "../HandleHttpErrors";
import SearchableDropdown from "../shared/SearchableDropdown";
import { MdLiveHelp } from "react-icons/md";
import { Spinner } from "react-bootstrap";
import HelpModal from "../shared/HelpModal";
import HelpContext from "../shared/context/HelpProvider";

const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({
  setRefreshMoamads,
  user,
  idz,
  activeMekhrazeem,
}) {
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);
  const axiosPrivate = useAxiosPrivate("application/json");
  const [megdarOptions, setMegdarOptions] = useState([]);
  const [famOptions, setFamOptions] = useState([]);
  const [show, toggleShow] = useState(false);
  const [showCopy, toggleShowCopy] = useState(false);
  const [mekhrazCopy, setMekhrazCopy] = useState({ mekhraz: 0 });
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState("בחר מכרז....");
  const [userEmail, setUserEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [isDpoChecked, setIsDpoChecked] = useState(false);
  const [isDpoCopyChecked, setIsDpoCopyChecked] = useState(false);
  const isMobile =
    /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(
      navigator.userAgent,
    );
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getMegdarType = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "megdartype/", {
          signal: controller.signal,
        });
        isMounted && setMegdarOptions(response.data[0].megdarOptions);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getMegdarType();

    const getFamType = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "famtype/", {
          signal: controller.signal,
        });
        isMounted && setFamOptions(response.data[0].famOptions);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getFamType();
  }, []);

  const [newMoamad, setNewMoamad] = useState({
    idz: idz,
    f_name: "",
    father_name: "",
    l_name: "",
    birth_date: "",
    megdar: "",
    fam_status: "",
    children_num: 0,
    citizenship: "ישראלית",
    special_needs: false,
    ethiopian: false,
    arab_droze_circassian: false,
    mobile_phone: "",
    home_phone: "",
    work_phone: "",
    Address: "",
    moamad_notes: "",
    zipcode: 0,
    mekhraz: 0,
    user: user,
  });

  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    setNewMoamad((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const [isTelValid, setTelIsValid] = useState(true);
  const handleTelBlur = () => {
    // Check if the length is exactly 11 characters
    setTelIsValid(newMoamad.mobile_phone.length === 11);
  };
  const handleTelChange = (e) => {
    e.preventDefault(); // prevent the default action
    const name = e.target.name;
    const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    let formattedValue = value;
    if (value.length > 10) {
      return; // Prevent input if length exceeds 10 digits (excluding hyphen)
    }

    if (value.length > 0) {
      formattedValue = `0${value.substring(1, 3)}-${value.substring(3, 10)}`;
    }

    setNewMoamad((prevState) => ({
      ...prevState,
      [name]: formattedValue,
    }));
  };

  const handleChangeSDD = (id, val) => {
    setNewMoamad((prevState) => ({
      ...prevState,
      mekhraz: id,
    }));
  };

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    setNewMoamad((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const handleDDSChangeCopy = (e) => {
    //e.preventDefault();
    const { name, value } = e.target;
    const n = Number(value);
    setMekhrazCopy(n);
  };
  const handleSubmitAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    let isMounted = true;
    const controller = new AbortController();

    const addData = async () => {
      try {
        const response = await axiosPrivate.post("/jobs/moamad/", newMoamad, {
          signal: controller.signal,
        });

        if (isMounted) {
          setRefreshMoamads((prev) => !prev);
          alert("הוספת המועמדות בוצעה בהצלחה,  נא להמשיך במילוי הפרטים.");
          toggleShow(false);
          setLoading(false);
          navigate(
            "/moamadoot/" +
              response.data.id +
              "/" +
              activeMekhrazeem.find((item) => item.id === response.data.mekhraz)
                .title +
              "/" +
              activeMekhrazeem.find((item) => item.id === response.data.mekhraz)
                .hagsha_date,
          );
        }
      } catch (err) {
        if (err.response) {
          alert(
            HandleHttpErrors(err.response.status) +
              "\n" +
              " או קיימת מועמדות במכרז זה.",
          );
          console.log(err.response);
        } else if (err.request) {
          alert(
            "The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert("Anything else");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    if (isTelValid) {
      await addData();
    } else {
      alert("מספר הטלפון הנייד לא תקין");
      setLoading(false); // Stop loading if validation fails
    }

    return () => {
      isMounted = false;
      controller.abort();
    };
  };

  const handleSubmitCopy = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const addData = async () => {
      try {
        const response = await axiosPrivate.post(
          "/jobs/copymoamadoot/",
          mekhrazCopy,
          {
            signal: controller.signal,
          },
        );

        isMounted && setRefreshMoamads((prev) => !prev);
        alert(
          "הוספת המועמד בוצעה בהצלחה, נא לכבנס לניהול ההצעה ולשהות את הפרטים הרצויים.",
        );
      } catch (err) {
        if (err.response) {
          alert(
            HandleHttpErrors(err.response.status) +
              "\n" +
              " או קיימת מועמדות במכרז זה.",
          );
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    addData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };
  if (loading) {
    // Render a spinner while the data is loading
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <HelpModal />
        <center>
          <h3>
            تذكر: لكي يتم بحث ترشحك، وبعد تعبئة كافة التفاصيل، عليك التوقيع
            وارسال الترشح عن طريق חתימה ושיגור قبل انتهاء موعد التقدم للمناقصة.
          </h3>
          <button
            className="btn btn-success btn-lg"
            style={{ margin: "5px" }}
            onClick={() => {
              toggleShow(!show);
              showCopy && toggleShowCopy(false);
            }}
          >
            {show ? "הסתר הוספה" : "הוספת מועמדות חדשה"}
          </button>

          <button
            className="btn btn-success btn-lg"
            style={{ margin: "5px" }}
            onClick={() => {
              toggleShowCopy(!showCopy);
              show && toggleShow(false);
            }}
          >
            {showCopy ? "הסתר שכפול" : " שכפל מועמדות אחרונה "}
          </button>
        </center>
        {showCopy && (
          <div className="card text-dark bg-light container p-3 border">
            <div className="card-header">
              <h3> הוספת מועמדות חדשה ע"י שכפול המועמדות האחרונה</h3>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmitCopy} className="mbsc-form-group">
                <div>
                  <label>בחר מכרז:</label>
                  <SearchableDropdown
                    options={activeMekhrazeem}
                    label="title_mkhnum"
                    id="id"
                    other="mkh_num"
                    selectedVal={value}
                    handleChange={(val, id, mkh_num) => {
                      setValue(val);
                      setMekhrazCopy(id);
                    }}
                    autoComplete="off"
                  />
                </div>{" "}
                <div
                  className="form-group"
                  style={{
                    maxWidth: "600px",
                    margin: "5px auto",
                    padding: "6px",
                    fontWeight: "bold",
                    backgroundColor: "#f9f9f9",
                    borderRadius: "3px",
                  }}
                >
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginBottom: "10px",
                    }}
                  >
                    הצהרת הסכמה למסירת מידע ושימוש בו במסגרת הליכי גיוס
                  </p>
                  <label
                    htmlFor="moamad_copy_dpo"
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "8px",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="checkbox"
                      id="moamad_copy_dpo"
                      name="moamad_copy_dpo"
                      checked={isDpoCopyChecked}
                      onChange={(e) => setIsDpoCopyChecked(e.target.checked)}
                      style={{
                        width: "24px",
                        height: "24px",
                        cursor: "pointer",
                        marginTop: "2px",
                        flexShrink: 0,
                      }}
                    />
                    <span>
                      ידוע לי כי המידע נמסר על ידי מרצוני החופשי לצורך השתתפותי
                      בהליכי מכרז לגיוס עובדים, וכי הוא יישמר במאגרי המידע של
                      הרשות המקומית למשך התקופה הנדרשת על פי דין. המידע ישמש
                      לצורך ניהול הליכי המכרז, תיעודם, עמידה בדרישות ביקורת,
                      דיווח ושמירת מסמכים, וכן לכל מטרה מותרת אחרת הקשורה בכך.
                      <br />
                      הובהר לי כי איני מחויב על פי חוק למסור את המידע, אולם
                      אי-מסירתו עלולה לפגוע באפשרות השתתפותי בהליך.
                      <br />
                      בלחיצה על הכפתור להלן אני מאשר/ת את נכונות, שלמות ועדכניות
                      הפרטים שמסרתי, וכן נותן/ת את הסכמתי לשימוש במידע כאמור.
                    </span>
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{
                      fontSize: "18px",
                      opacity: isDpoCopyChecked ? 1 : 0.6,
                    }}
                    disabled={!isDpoCopyChecked}
                  >
                    אישור שיכפול
                  </button>
                  {!isDpoCopyChecked && (
                    <div
                      style={{
                        color: "#dc3545",
                        fontSize: "14px",
                        marginTop: "6px",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <span>⚠️</span>
                      <span>
                        אתה לא יכול להוסיף את מועמדותך לפני אישור הצהרת מסירה
                        ושימוש במידע
                      </span>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        )}
        {/*show && !isMobile && (
          <JotForm user={user} idz={idz} activeMekhrazeem={activeMekhrazeem} />
        )*/}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {" "}
          <h3
            onClick={() => {
              setSaeef("moamadoiot");
              setShowHelp(true);
            }}
          >
            <span className="help">
              <MdLiveHelp />
            </span>
          </h3>
        </div>
        {show && (
          <div className="card text-dark bg-light container p-3 my-3 border">
            <div className="card-header">
              <center>
                <h3> הוספת מועמדות חדשה למכרז</h3>
              </center>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmitAdd} className="mbsc-form-group">
                <div>
                  <label className="required-label">בחר מכרז:</label>
                  <SearchableDropdown
                    options={activeMekhrazeem}
                    label="title_mkhnum"
                    id="id"
                    other="mkh_num"
                    selectedVal={value}
                    handleChange={(val, id, mkh_num) => {
                      setValue(val);
                      //setUserEmail(email);
                      handleChangeSDD(id, val);
                    }}
                    required
                  />
                </div>
                <div className="table-responsive">
                  <table className="table">
                    <tbody>
                      <tr>
                        <td className="minimum-td-width">
                          <div className="form-group">
                            <label htmlFor="f_name" className="required-label">
                              שם פרטי
                            </label>
                            <input
                              type="text"
                              name="f_name"
                              value={newMoamad.f_name}
                              onChange={handleChange}
                              className="form-control"
                              id="f_name"
                              placeholder=""
                              required
                            />
                          </div>
                        </td>
                        <td className="minimum-td-width">
                          <div className="form-group">
                            <label htmlFor="father_name">שם אב/אמצעי</label>
                            <input
                              type="text"
                              name="father_name"
                              value={newMoamad.father_name}
                              onChange={handleChange}
                              className="form-control"
                              id="father_name"
                              placeholder=""
                            />
                          </div>
                        </td>
                        <td className="minimum-td-width">
                          <div className="form-group">
                            <label htmlFor="l_name" className="required-label">
                              שם משפחה
                            </label>
                            <input
                              type="text"
                              name="l_name"
                              value={newMoamad.l_name}
                              onChange={handleChange}
                              className="form-control"
                              id="l_name"
                              placeholder=""
                              required
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="form-group text-right">
                          <div className="form-group text-right">
                            <label htmlFor="idz">מס תעודת זהות אוטומטי</label>
                            {" " + newMoamad.idz}
                          </div>
                        </td>
                        <td className="minimum-td-width">
                          <div className="form-group">
                            <label
                              htmlFor="birth_date"
                              className="required-label"
                            >
                              תאריך לידה
                            </label>
                            <input
                              type="date"
                              name="birth_date"
                              value={newMoamad.birth_date}
                              onChange={handleChange}
                              className="form-control"
                              id="birth_date"
                              placeholder=""
                              required
                            />
                          </div>
                        </td>

                        <td className="minimum-td-width">
                          <div className="form-group">
                            <label htmlFor="megdar" className="required-label">
                              מגדר
                            </label>
                            <br />
                            <select
                              name="megdar"
                              onChange={handleChange}
                              value={newMoamad.megdar}
                              required
                              autoComplete="off"
                            >
                              <option key="0" value="" selected>
                                בחר סוג
                              </option>
                              {megdarOptions?.map((a) => (
                                <option key={a[0]} value={a[1]}>
                                  {a[1]}
                                </option>
                              ))}
                            </select>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="minimum-td-width">
                          <div className="form-group">
                            <label htmlFor="children_num">מספר ילדים</label>
                            <input
                              type="number"
                              name="children_num"
                              value={newMoamad.children_num}
                              onChange={handleChange}
                              className="form-control"
                              id="children_num"
                              placeholder="כמו 3"
                            />
                          </div>
                        </td>
                        <td className="minimum-td-width">
                          <div className="form-group">
                            <label
                              htmlFor="fam_status"
                              className="required-label"
                            >
                              מצב משפחתי
                            </label>
                            <br />
                            <select
                              name="fam_status"
                              onChange={handleChange}
                              value={newMoamad.fam_status}
                              required
                              autoComplete="off"
                            >
                              <option key="0" value="" selected>
                                בחר מצב משפחתי
                              </option>
                              {famOptions.map((a) => (
                                <option key={a[0]} value={a[1]}>
                                  {a[1]}
                                </option>
                              ))}
                            </select>
                          </div>
                        </td>
                        <td className="minimum-td-width">
                          <div className="form-group">
                            <label
                              htmlFor="citizenship"
                              className="required-label"
                            >
                              אזרחות
                            </label>
                            <input
                              type="text"
                              name="citizenship"
                              value={newMoamad.citizenship}
                              onChange={handleChange}
                              className="form-control"
                              id="citizenship"
                              placeholder=""
                              required
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="minimum-td-width">
                          <div className="form-group">
                            <label htmlFor="special_needs">
                              בעל צרכים מיוחדים?
                            </label>
                            <input
                              type="checkbox"
                              id="special_needs"
                              name="special_needs"
                              checked={newMoamad.special_needs}
                              onChange={handleCheckBoxChange}
                            />
                          </div>
                        </td>
                        <td className="minimum-td-width">
                          <div className="form-group">
                            <input
                              type="checkbox"
                              id="arab_droze_circassian"
                              name="arab_droze_circassian"
                              checked={newMoamad.arab_droze_circassian}
                              onChange={handleCheckBoxChange}
                            />{" "}
                            <label htmlFor="arab_droze_circassian">
                              נמנה על האוכלוסיה הערבית, הדרוזית או הצרקסית?
                            </label>
                          </div>
                        </td>
                        <td className="minimum-td-width">
                          <div className="form-group">
                            <input
                              type="checkbox"
                              id="ethiopian"
                              name="ethiopian"
                              checked={newMoamad.ethiopian}
                              onChange={handleCheckBoxChange}
                            />{" "}
                            <label htmlFor="ethiopian">אתיופי?</label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="minimum-td-width">
                          <div className="form-group">
                            <label
                              htmlFor="mobile_phone"
                              className="required-label"
                            >
                              מספר נייד
                            </label>
                            <input
                              type="text"
                              name="mobile_phone"
                              value={newMoamad.mobile_phone}
                              onChange={handleTelChange}
                              onBlur={handleTelBlur}
                              className="form-control"
                              id="mobile_phone"
                              maxLength="11" // Maximum length to fit the format 0XX-XXXXXXX
                              placeholder="0XX-XXXXXXX"
                              required
                            />
                            {!isTelValid && (
                              <div style={{ color: "red" }}>
                                מספר נייד לא תקין.
                              </div>
                            )}
                          </div>
                        </td>
                        <td className="minimum-td-width">
                          <div className="form-group">
                            <label htmlFor="mobile_phone">טלפון בעבודה</label>
                            <input
                              type="text"
                              name="work_phone"
                              value={newMoamad.work_phone}
                              onChange={handleChange}
                              className="form-control"
                              id="work_phone"
                            />
                          </div>
                        </td>
                        <td className="minimum-td-width">
                          <div className="form-group">
                            <label htmlFor="home_phone">טלפון בבית</label>
                            <input
                              type="text"
                              name="home_phone"
                              value={newMoamad.home_phone}
                              onChange={handleChange}
                              className="form-control"
                              id="home_phone"
                              placeholder=""
                            />
                          </div>
                        </td>
                      </tr>
                      {isMobile && (
                        <tr>
                          <td colSpan="3">
                            {" "}
                            <div className="form-group">
                              <label
                                htmlFor="Address"
                                className="required-label"
                              >
                                כתובת
                              </label>
                              <input
                                type="text"
                                name="Address"
                                value={newMoamad.Address}
                                onChange={handleChange}
                                className="form-control"
                                id="Address"
                                required
                              />
                            </div>
                          </td>
                        </tr>
                      )}
                      <tr>
                        {!isMobile && (
                          <td className="minimum-td-width">
                            <div className="form-group">
                              <label
                                htmlFor="Address"
                                className="required-label"
                              >
                                כתובת
                              </label>
                              <input
                                type="text"
                                name="Address"
                                value={newMoamad.Address}
                                onChange={handleChange}
                                className="form-control"
                                id="Address"
                                required
                              />
                            </div>
                          </td>
                        )}
                        <td className="minimum-td-width">
                          <div className="form-group">
                            <label htmlFor="zipcode">מיקוד</label>
                            <input
                              type="number"
                              name="zipcode"
                              value={newMoamad.zipcode}
                              onChange={handleChange}
                              className="form-control"
                              id="zipcode"
                            />
                          </div>
                        </td>
                        <td className="minimum-td-width">
                          <div className="form-group">
                            <label htmlFor="userEmail">
                              דואר אלקטרוני-אוטומטי-
                            </label>
                            {userEmail}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={3}>
                          <div
                            className="form-group"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <label
                              htmlFor="moamad_notes"
                              style={{ textAlign: "center" }}
                            >
                              משהו טוב שרוצה לספר
                            </label>
                            <textarea
                              name="moamad_notes"
                              cols={50}
                              rows={2}
                              value={newMoamad.moamad_notes}
                              onChange={handleChange}
                              className="form-control"
                              id="moamad_notes"
                              style={{ textAlign: "center" }}
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  className="form-group"
                  style={{
                    maxWidth: "600px",
                    margin: "5px auto",
                    padding: "6px",
                    fontWeight: "bold",
                    backgroundColor: "#f9f9f9",
                    borderRadius: "3px",
                  }}
                >
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginBottom: "10px",
                    }}
                  >
                    הצהרת הסכמה למסירת מידע ושימוש בו במסגרת הליכי גיוס
                  </p>
                  <label
                    htmlFor="moamad_dpo"
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "8px",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="checkbox"
                      id="moamad_dpo"
                      name="moamad_dpo"
                      checked={isDpoChecked}
                      onChange={(e) => setIsDpoChecked(e.target.checked)}
                      style={{
                        width: "24px",
                        height: "24px",
                        cursor: "pointer",
                        marginTop: "2px",
                        flexShrink: 0,
                      }}
                    />
                    <span>
                      ידוע לי כי המידע נמסר על ידי מרצוני החופשי לצורך השתתפותי
                      בהליכי מכרז לגיוס עובדים, וכי הוא יישמר במאגרי המידע של
                      הרשות המקומית למשך התקופה הנדרשת על פי דין. המידע ישמש
                      לצורך ניהול הליכי המכרז, תיעודם, עמידה בדרישות ביקורת,
                      דיווח ושמירת מסמכים, וכן לכל מטרה מותרת אחרת הקשורה בכך.
                      <br />
                      הובהר לי כי איני מחויב על פי חוק למסור את המידע, אולם
                      אי-מסירתו עלולה לפגוע באפשרות השתתפותי בהליך.
                      <br />
                      בלחיצה על הכפתור להלן אני מאשר/ת את נכונות, שלמות ועדכניות
                      הפרטים שמסרתי, וכן נותן/ת את הסכמתי לשימוש במידע כאמור.
                    </span>
                  </label>
                </div>
                <div>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{
                      fontSize: "18px",
                      opacity: isDpoChecked ? 1 : 0.6,
                    }}
                    disabled={!isDpoChecked}
                  >
                    הוסף מועמדות חדשה והמשך במילוי שאר הפרטים
                  </button>
                  {!isDpoChecked && (
                    <div
                      style={{
                        color: "#dc3545",
                        fontSize: "14px",
                        marginTop: "6px",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <span>⚠️</span>
                      <span>
                        אתה לא יכול להוסיף את מועמדותך לפני אישור הצהרת מסירה
                        ושימוש במידע
                      </span>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    );
  }
}
